// user context to be used by app
import { createContext } from 'react';

const UserContext = createContext();

export default UserContext;
